<template>
  <div class="card-dialog">
    <el-dialog
      title="修改会员等级"
      :visible="true"
      :show-close="false"
      @close="handleClose"
    >
      <div class="box">
        <el-select v-model="value" placeholder="请选择会员等级">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.userLevelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="save">确定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
  export default {
    name: "DialogLevel",
    data(){
      return{
        options: [],
        value: ''
      }
    },
    props: {
      row: {
        type: Object,
        default: ()=>({})
      }
    },
    created() {
      this.value = this.row?.levelId ? this.row?.levelId + '' : ''
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList(){
        const res = await this.$http.get('user/level/list')
        this.options = res.data.data.map(v=>{
          return{
            ...v,
            id: v.id + ''
          }
        })
        this.options.unshift({
          id: '',
          userLevelName: '无'
        })
      },
      handleClose(){
        this.$options.cancel('cancel')
      },
      async save(){
        const params = {
          userId: this.row.userId,
          levelId: this.value,
        }
        const res = await this.$http.get('/user/level/binding', {params})
        if(res.data.code === 200){
          this.$options.confirm(true)
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .card-dialog {
    ::v-deep .el-dialog {
      width: 400px;
    }

    ::v-deep .el-dialog__header {
      text-align: center;
      padding-bottom: 0;
    }

    .box{
      text-align: center;
      .el-button{
        width: 100px;
        text-align: center;
        margin: 20px auto 0;
      }
    }
  }
</style>
